import React from "react";
import { ReactSession } from 'react-client-session';
import {encode as base64_encode} from 'base-64';

import { Helpers } from "../../config/Helpers";

class MutasiKomisi extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessKodeNasabah: (ReactSession.get("sess_kodenasabah")) ? ReactSession.get("sess_kodenasabah") : '',
            loading: true,
            summaryData: '',
            data: [],
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.loadBalance();
        }
    }

    loadBalance = () => {
        this.setState({ loading: true });

        Helpers.getSummary(this.state.sessUserCode, this.state.sessKodeNasabah).then(res => {
            if(res && res.length > 0){
                this.setState({
                    summaryData: res[0]
                }, () => {
                    Helpers.getMutasiKomisi(this.state.sessUserCode).then(res2 => {
                        this.setState({
                            data: (res2) ? res2 : [],
                            loading: false
                        });
                    });
                });
            }else{
                this.setState({ loading: false });
            }
        });
    };

    render() {
        const { summaryData } = this.state;

        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./account" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Waroq Poin</h1>
                    </div>

                    <div className="detail-wrap">
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Saldo Waroq Poin</span>
                            </div>

                            {
                                this.state.loading ? (
                                    <div className="detail-info-box">
                                        <div className="detail-info-row">
                                            <span className="detail-info-label">Memuat data...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="collective-total-value">Rp {parseInt((summaryData && summaryData.commission_now_raw) || 0).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</div>
                                )
                            }
                        </div>

                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Riwayat Transaksi</span>
                            </div>

                            {
                                this.state.loading ? (
                                    <div className="detail-info-box">
                                        <div className="detail-info-row">
                                            <span className="detail-info-label">Memuat data...</span>
                                        </div>
                                    </div>
                                ) : this.state.data.length > 0 ? (
                                    this.state.data.map((object, i) => (
                                        <div className="collective-history-item" key={i}>
                                            <div className="collective-history-top">
                                                <span className="collective-history-date">{object.TanggalTransaksi}</span>
                                                <i className={(object.Status === 'in') ? 'fi-rs-download' : 'fi-rs-upload'}></i>
                                                <span className="collective-history-code">{object.Jenis}</span>
                                                <span className="collective-history-amount" style={{color: (object.Status === 'in') ? '#02A85C' : '#F94D60'}}>
                                                    {(object.Status === 'in') ? '+ ' : '- '}Rp {object.Total}
                                                </span>
                                            </div>
                                            <div className="collective-history-bottom">
                                                <span>{object.KodeOrder}</span>
                                                <span>{object.waktu ? object.waktu + ' WIB' : ''}</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="order-empty">
                                        <i className="fi-rs-receipt"></i>
                                        <p>Belum ada riwayat transaksi</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default MutasiKomisi;
